import { useQuery } from "@tanstack/react-query";
import { getAccountOfStoreApiRequest } from "../../services";
import { useAccountOfStore } from "../../store";

export const useGetAllAccountOfStoreApi = ({ reload }: { reload?: boolean }) => {
  const { storeId } = useAccountOfStore();
  const { data, isLoading } = useQuery({
    queryKey: ["all-account-of-store", storeId, reload],
    queryFn: () => getAccountOfStoreApiRequest(storeId),
    enabled: true,
  });
  return {
    accountOfStore: data,
    isLoading,
  };
};
